// extracted by mini-css-extract-plugin
export default {"promoBoxContainer":"_1nqv622","promoWithBadge":"_we46fd","promoBox":"_1nakwk7"};